import myAxios from "../utils/request";
export default {
  addData(params) {
    return myAxios.post("/api/News/InsertNews", params);
  },
  modifyData(params) {
    return myAxios.post("/api/News/UpdateNews", params);
  },
  getInfo(params) {
    const { id } = params;
    return myAxios.get(`/api/News/GetNewsById?id=${id}`);
  }
};
